import QuickLinkValue from './QuickLinkValue';

class QuickLink {
  quickLinkId = 0;

  name = '';

  quickLinkValues = [];

  constructor(quickLink) {
    this.quickLinkId = quickLink.quickLinkId;
    this.name = quickLink.name;
    this.quickLinkValues = QuickLinkValue.fromObjects(quickLink.quickLinkValues);
  }

  static fromObject(data) {
    if (data == null) {
      return null;
    }
    
    return new QuickLink(data);
  }

  static fromObjects(list) {
    if (list == null) {
      return null;
    }

    return list.map((data) => QuickLink.fromObject(data));
  }
}

export default QuickLink;
